// Разбор тела ошибочного ответа backend в человекочитаемое сообщение — вынесено из
// api/client.ts::request() отдельной чистой функцией (не тянет fetch/@twa-dev/sdk), чтобы можно
// было юнит-тестировать без DOM/окружения браузера (см. errorMessage.test.ts), тот же приём, что
// и lib/pricing.ts.
//
// FastAPI HTTPException отдаёт JSON {"detail": "человекочитаемое сообщение"} — до 2026-08-20 весь
// текст ответа (сама строка `{"detail":"..."}`) шёл пользователю на экран как есть (замечено на
// дублирующемся промокоде: `{"detail":"Этот промокод уже был использован"}` вместо просто текста).

export function extractErrorMessage(body: string, fallback: string): string {
  const trimmedFallback = body || fallback;
  try {
    const parsed: unknown = JSON.parse(body);
    if (
      parsed &&
      typeof parsed === "object" &&
      typeof (parsed as { detail?: unknown }).detail === "string"
    ) {
      return (parsed as { detail: string }).detail;
    }
  } catch {
    // не JSON (например, 502 от nginx с HTML-страницей) — оставляем как есть
  }
  return trimmedFallback;
}
